import { Modal, Form, Select, Input } from "antd";

const FieldTransformModal = ({
  disabled,
  open,
  setOpen,
  transformForm,
  fieldPath,
  handleFieldMappingChange,
  onValuesChange,
}) => {
  return (
    <Modal
      centered
      title="轉換規則設定"
      width={800}
      open={open}
      okButtonProps={{ autoFocus: true, htmlType: "submit" }}
      onCancel={() => setOpen(false)}
      modalRender={(dom) => (
        <Form
          form={transformForm}
          disabled={disabled}
          onValuesChange={onValuesChange}
          onFinish={(values) => {
            handleFieldMappingChange(
              fieldPath + ".source.transformations",
              values
            );
            setOpen(false);
          }}
        >
          {dom}
        </Form>
      )}
      styles={{ body: { paddingTop: "20px" } }}
    >
      <Form.Item shouldUpdate>
        {() => (
          <div>
            <Form.Item
              name="type"
              label="轉換類型"
              rules={[{ required: true, message: "請選擇轉換類型" }]}
            >
              <Select
                placeholder="請選擇轉換類型"
                options={[
                  { value: "calculation", label: "計算轉換" },
                  { value: "concat", label: "字串串接" },
                  { value: "others", label: "其他" },
                ]}
              />
            </Form.Item>

            {transformForm.getFieldValue("type") === "calculation" ? (
              <Form.Item name="formula" label="計算公式">
                <Input
                  placeholder={`請用 \${} 表示數值變數，例如：\${key} *100`}
                />
              </Form.Item>
            ) : transformForm.getFieldValue("type") === "concat" ? (
              <Form.Item name="content" label="串接內容">
                <Input
                  placeholder={`請用 \${} 表示數值變數，例如：\${日期}-\${key}`}
                />
              </Form.Item>
            ) : null}

            <Form.Item name="note" label="備註">
              <Input
                placeholder={`其他轉換備註，例如：串接內容中的 \${日期} 表示方式為 YYY-MMM-DD`}
              />
            </Form.Item>
          </div>
        )}
      </Form.Item>
    </Modal>
  );
};

export default FieldTransformModal;
